import { render, staticRenderFns } from "./ServicesPaymentRefund.vue?vue&type=template&id=035805ca&scoped=true&"
import script from "./ServicesPaymentRefund.vue?vue&type=script&lang=js&"
export * from "./ServicesPaymentRefund.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035805ca",
  null
  
)

export default component.exports